import { fetchGet } from "../../../service/api_client";

const ACCESS_LOG_NOISE_KEYS = new Set([
  "_id",
  "id",
  "__v",
  "created_at",
  "updated_at",
  "created_by",
  "updated_by",
  "created_by_name",
  "updated_by_name",
  "deleted",
  "deleted_at",
  "deleted_by",
  "deleted_by_name",
]);

const normalizeAccessLogs = (logs: any[]) => {
  return logs.map((log) => {
    const oldValues = log.old_values || {};
    const newValues = log.new_values || {};

    const changes = Object.keys({ ...oldValues, ...newValues })
      .filter((key) => !ACCESS_LOG_NOISE_KEYS.has(key))
      .map((key) => ({
        field: key,
        oldValue: oldValues[key] ?? "-",
        newValue: newValues[key] ?? "-",
      }));

    if (Array.isArray(log.added_roles) && log.added_roles.length > 0) {
      changes.push({
        field: "Roles added",
        oldValue: "-",
        newValue: log.added_roles.map((r: any) => r.title).join(", "),
      });
    }
    if (Array.isArray(log.removed_roles) && log.removed_roles.length > 0) {
      changes.push({
        field: "Roles removed",
        oldValue: log.removed_roles.map((r: any) => r.title).join(", "),
        newValue: "-",
      });
    }

    return {
      id: log.id || log._id,
      user: log.by_user_name,
      log_type: log.log_type,
      operation:
        log.operation || `${log.by_user_name ?? ""} ${log.log_type ?? ""}`,
      created_at: log.created_at,
      remarks: log.remarks,
      changes,
    };
  });
};

export const GetAccessManagementLogsApi = async ({
  entityId,
  page,
  count,
}: {
  entityId: string;
  page: number;
  count: number;
}) => {
  const query = new URLSearchParams({
    page: String(page),
    count: String(count),
  });

  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/users/access-logs/${entityId}?${query}`;

  const res = await fetchGet(url);
  if (!res.success) return res;

  return {
    ...res,
    data: {
      ...res.data,
      logs: normalizeAccessLogs(res.data.logs),
    },
  };
};
